import { useVAdminSelectedIncident } from "#root/queries/local";
import BaseMapVictims from "#root/components/BaseMapVictims";
import { Breadcrumbs } from "#root/components/Breadcrumbs";

const MapVictims: React.FC = () => {
    const { selectedIncidentId: vAdminIncidentId, setVAdminSelectedIncidentId } = useVAdminSelectedIncident();

    const handleIncidentChange = (id: string | null) => {
        if (id) {
            setVAdminSelectedIncidentId(id);
        }
    };

    return (
        <BaseMapVictims
            customHeaderContent={
                <div className="emc-page-header">
                    <div className="emc-page-header__top-row">
                        <div className="emc-page-header__breadcrumbs">
                            <Breadcrumbs />
                        </div>
                    </div>
                    <div className="emc-page-header__title">
                        <h2>Map Victims <div className="divider" /></h2>
                    </div>
                </div>
            }
            initialIncidentId={vAdminIncidentId || ''}
            onIncidentChange={handleIncidentChange}
            mode="admin"
        />
    );
};

export default MapVictims;